// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__2Xde0","sub":"style_sub__1QcvM","text":"style_text__18r26","icon":"style_icon__2Mt5f","title":"style_title__1P6os","arrow":"style_arrow__1qB_G"};